export default "__VITE_ASSET__9f8e094e__"